
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Navbar from './components/Layout/Navbar';
import Contact from './Pages/Contact';
import ErrorPage from './Pages/ErrorPage'
import Projects from './Pages/Projects';
import Footer from './Pages/Footer';
import ServicesDetails from './components/Home/ServicesDetails';
import WebDevelopmentDetails from './components/Services/WebDevelopmentDetails';
import MobileDevelopmentDetails from './components/Services/MobileDevelopmentDetails';
import UIDesignDetails from './components/Services/UIDesignDetails';
import MachineLearningDetails from './components/Services/MachineLearningDetails';
import CloudComputingDetails from './components/Services/CloudComputingDetails';
import DataAnalyticsDetails from './components/Services/DataAnalyticsDetails';


function App() {
  return (
    <div className='bg-[#030303] text-white'>
      <Navbar/>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/projects' element={<Projects/>}/>
          <Route path='*' element={<ErrorPage/>}/>
          <Route path='/service-details' element={<ServicesDetails/>}/>
          <Route path='/services/web-development' element={<WebDevelopmentDetails/>}/>
          <Route path='/services/mobile-development' element={<MobileDevelopmentDetails/>}/>
          <Route path='/services/ui-ux-design' element={<UIDesignDetails/>}/>
          <Route path='/services/machine-learning' element={<MachineLearningDetails/>}/>
          <Route path='/services/cloud-computing' element={<CloudComputingDetails/>}/>
          <Route path='/services/data-analytics' element={<DataAnalyticsDetails/>}/>
        </Routes>
      <Footer/>
    </div>
  );
}

export default App;
